import request from '@/utils/request';
// 资源审核

// 审核列表
export function resourceList(data) {
	return request({
		url: '/management/audit/open-resource/list',
		method: 'post',
		data: data
	})
}

// 审核
export function resourceUpdate(data) {
	return request({
		url: '/management/audit/open-resource/update',
		method: 'post',
		data: data
	})
}

// 审核人
export function auditorList(data) {
	return request({
		url: '/management/audit/open-resource/auditor/list',
		method: 'post',
		data: data
	})
}

// 打分
export function evaluate(data) {
	return request({
		url: '/management/reward/resource/evaluate',
		method: 'post',
		data: data
	})
}